import "./styles.scss";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";
import { useFaq } from "context/client/faq";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import {
  FaqTable,
  FaqTiles,
  FaqContentAside,
  FaqFilters,
  FaqContentModal,
} from "./components";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "faq-content";

const FaqContent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { websites } = useApp();
  const { selected, setSelected } = useFaq();

  const actions = [
    {
      label: t("Add new website"),
      href: "/websites/new",
      event: () =>
        window.gtag("event", "new_website", {
          click_text: t("Add new website"),
          click_url: `/websites/new`,
        }),
    },
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  if (websites?.length === 0) return navigate("/websites");

  return (
    <>
      <DashboardContentLayout
        variant="faq"
        header={{
          label: t("FAQ"),
          description: t("Answers to the most frequently asked questions."),
          actions: !max.lg ? <FaqFilters /> : undefined,
        }}
        aside={<FaqContentAside />}
        actions={actions}
      >
        <div className={mainClass}>{max.lg ? <FaqTiles /> : <FaqTable />}</div>
      </DashboardContentLayout>

      <FaqContentModal
        data={selected}
        isOpen={!!selected}
        onClose={() => setSelected(null)}
      />
    </>
  );
};

export default FaqContent;
